var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-box"},[_c('div',{staticClass:"stats-box__label"},[_vm._t("label")],2),_c('div',{staticClass:"stats-box__value"},[_vm._t("value")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }